import { parsePhoneNumberFromString } from 'libphonenumber-js/max';
// Country-aware length validation avoids rejecting newly allocated valid prefixes.
export function normalizePhone(value, country = 'GB') {
  const raw = String(value ?? '').trim().slice(0, 80);
  const selected = String(country || 'GB').toUpperCase();
  const candidate = raw.replace(/^00/, '+');
  let phone;
  try { phone = parsePhoneNumberFromString(candidate, selected === 'OTHER' ? undefined : selected); } catch {}
  return { raw, normalized: phone?.number || '', country: phone?.country || selected,
    possible: !!phone && phone.isPossible() &&
      !(phone.country === 'GB' && /^7/.test(phone.nationalNumber) && phone.nationalNumber.length !== 10) &&
      !/[a-z]/i.test(raw) };
}
